import {
  sign_in as outseta_sign_in,
  sign_up as outseta_sign_up,
} from './outsetaLinks';
const redirect_sign_in = 'https://www.propertycast.io/login';
const redirect_sign_up = 'https://www.propertycast.io/pricing';

const getSignInLinks = () => {
  const hostname = window.location.hostname;

  if (
    hostname === 'localhost' ||
    hostname === 'capcalc-1e78f.firebaseapp.com' ||
    hostname === 'staging.propertycast.io'
  ) {
    return { sign_in: outseta_sign_in, sign_up: outseta_sign_up };
  }

  return { sign_in: redirect_sign_in, sign_up: redirect_sign_up };
};

export default getSignInLinks;
